import { render, staticRenderFns } from "./CollectListUpdateLayout.vue?vue&type=template&id=217428c8&scoped=true"
import script from "./CollectListUpdateLayout.vue?vue&type=script&lang=js"
export * from "./CollectListUpdateLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217428c8",
  null
  
)

export default component.exports